module.exports = __webpack_public_path__ + "static/media/roundedrect-tertiary-wide.bd754042.png";